<script setup>
import {computed} from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const model = defineModel() // v-model = selectedPeriodKey

const props = defineProps({
    listFilters: {
        type: Array,
        required: true,
    },
    disabled: Boolean,
})

const selectedItem = computed(() =>
    props.listFilters.find(f => f.key === model.value)
)

function selectFilter(key) {
    model.value = key
}

</script>

<template>
    <v-menu v-if="!props.disabled">
        <template v-slot:activator="{ props: menuProps }">
            <button
                type="button"
                v-bind="menuProps"
                class="card-header-menu d-inline-block border-radius me-3"
            >
                {{ selectedItem?.label }}
            </button>
        </template>

        <v-list class="menu-content">
            <v-list-item
                v-for="(item, index) in props.listFilters"
                :key="item.key"
                @click="selectFilter(item.key)"
            >
                <button
                    type="button"
                    class="bg-transparent border-none"
                    :class="{ active: model === item.key }"
                >
                    {{ $t(item.label) }}
                </button>
            </v-list-item>
        </v-list>
    </v-menu>

    <template v-else>
        <button
            type="button"
            class="card-header-menu d-inline-block border-radius me-3"
        >
            {{ selectedItem?.label }}
        </button>
    </template>
</template>

